if (!customElements.get("price-normalize")) {
    interface DiscountCodesStoraged {
      discounts_cupons: {
        discount_codes: Record<string, Points | Cashback>
      }
      code: string
      message_color: any[]
      data: { discount: Discount }
      discount_config: any
      disable_default_message: boolean
      discount_default: {
        timestamp: string
        customRules: any[]
        discount: Discount
        valid: boolean
        warnings: any[]
      }
    }

    interface Points {
      type: string
      multiplier: number
      multiplier_club: number
      text_grup_1: string
      text_grup_2: string
    }

    interface Cashback {
      type: string
      multiplier: number
    }

    interface Discount {
      allocation_method: string
      target_selection: string
      target_type: string
      value: string
      value_type: string
      allocation_limit: any
      entitled_product_ids: any[]
      entitled_variant_ids: any[]
      entitled_collection_ids: number[]
      usage_count: number
      usage_limit: any
      changed_value: boolean
      code: string
    }

    class PriceNormalize extends HTMLElement {
      static get observedAttributes() {
        return ["data-compare-at-price", "data-pristine-price", "data-timestamp"];
      }
      discountCodesStoraged: DiscountCodesStoraged | null = null;
      giftCardAllowList: { codes: string[], default_discount_code: string, default_discount_value: string } | null = null;
      pristinePrice?: number;
      productId?: number;
      productCollection?: number[];
      PriceNormalizeResolveType: (candidate: any) => string | undefined;
      conditionsValues: any = {
        hasAppliedDiscountCode: false,
        hasMarkdown: false,
        isDiscountCodeAppliedValidForProduct: false,
        isCashbackDiscountCode: false,
        isPointsDiscountCode: false,
        isPixDiscountCodeActive: false,
        isKit: false,
        isHomogeneousKit: false
      }
      toLogger: boolean = false

      constructor() {
        super();
        this.PriceNormalizeResolveType = window.PriceNormalizeResolveType || (() => undefined);
        this.toLogger = sessionStorage.getItem('insider:debug:price-normalize') === 'true' ? true : false;
        this.init();
      }

      attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (!!oldValue) {
          if (name === "data-timestamp") {
            this.log("[attributeChangedCallback]", " fired by:", this.dataset.timestamp.split("-")[0])
            this.init();
          }
        }
      }

      log(...args: any[]) {
        if (this.toLogger)
          console.log("%c[DEBUG]", "color:red;",`[ProductID: ${this.dataset.productId}]`, ...args);
      }

      getDiscountCodeStoraged() {
       this.log("getDiscountCodeStoraged")
        const handlePromotionCouponReady = () => {
          const data = sessionStorage.getItem('insider:cart:promotionCoupon');
          if (data) this.discountCodesStoraged = JSON.parse(data) as DiscountCodesStoraged;
        }
        handlePromotionCouponReady();
        window.addEventListener('PromotionCouponReady', () => {
          this.dataset.timestamp = `priceNormalize:getDiscountCodeStoraged:PromotionCouponReady-${new Date().toISOString()}`;
          handlePromotionCouponReady();
          this.init();
        });
      }

      getGiftCardAllowList() {
        const data = JSON.parse(document.querySelector("script[type='application/json']#giftcardDiscountAllowList").innerHTML);
        this.giftCardAllowList = {
          ...data,
          codes: data.codes.split(",").filter(Boolean)
        }
      }

      init() {
        if (this.parentElement === null) return;
        this.log("PriceNormalize initialized")
        this.getDiscountCodeStoraged()
        // this.getGiftCardAllowList()
        this.setPriceConditions()
        const resolvedType = this.PriceNormalizeResolveType(this.conditionsValues);
        const priceObject = this.createPriceObject(resolvedType);
        this.renderPrices(priceObject);
      }

      createPriceObject(type: string | undefined): any {
        this.log("Creating price object with type:", type);
        let discountValue, discountCode;
        const partnerDiscountType = this.discountCodesStoraged?.discount_config?.type;

        const hasOtherDiscountCode = this.discountCodesStoraged?.code;
        const productCollections = this.dataset?.productCollections?.split(",").map(Number) || [];
        const productId = Number(this.dataset?.productId);

        // Função para validar se o desconto é aplicável ao produto/coleção
        const isDiscountValid = (discountSource) => {
          if (!discountSource) return false;
          if (discountSource?.discount?.allocation_method === "across") return true;
          if (discountSource?.discount?.allocation_method === "each") {
            const collections = discountSource?.discount?.entitled_collection_ids || [];
            const products = discountSource?.discount?.entitled_product_ids || [];
            return collections.some(id => productCollections.includes(id)) || products.includes(productId);
          }

          return false;
        };

        // Define o desconto e código a serem aplicados
        if (hasOtherDiscountCode && isDiscountValid(this.discountCodesStoraged?.data)) {
          discountValue = this.discountCodesStoraged?.data?.discount?.value;
          discountCode = this.discountCodesStoraged?.code;
        } else {
          discountValue = this.discountCodesStoraged?.discount_default?.discount?.value;
          discountCode = this.discountCodesStoraged?.discount_default?.discount?.code;
        }

        // Demais configurações de desconto
        const discountType = this.discountCodesStoraged?.discount_default?.discount?.value_type || partnerDiscountType;
        const partnerDiscountCode = this.discountCodesStoraged?.code;
        const discountConfigMultiplier = this.discountCodesStoraged?.discount_config?.multiplier;
        const discountConfigMultiplierClub = this.discountCodesStoraged?.discount_config?.multiplier_club;
        const discountConfigTextGrup1 = this.discountCodesStoraged?.discount_config?.text_grup_1;
        const discountConfigTextGrup2 = this.discountCodesStoraged?.discount_config?.text_grup_2;
        const kitUpsell = Array.from({ length: 3 }, (_, i) => {
        const index = i + 1;
        return {
          [`product${index}Id`]: this.getAttribute(`data-upsell-product-${index}-id`),
          [`kitUnitPrice`]: this.getAttribute(`data-upsell-product-${index}-price`),
          [`kitUnitFinalPrice`]: this.getAttribute(`data-upsell-product-${index}-kit-final-price`),
          [`kitUnitCompareAtPrice`]: this.getAttribute(`data-upsell-product-${index}-compare-at-price`),
          [`kitUnitTitle`]: this.getAttribute(`data-upsell-product-${index}-title`),
          [`kitUnitPriceWithPixDiscount`]: this.calculatePrice(Number(this.getAttribute(`data-upsell-product-${index}-price`)), Math.abs(Number(this.dataset.pixDiscountValue))),
          [`kitUnitPriceWithDiscountCode`]: this.calculatePrice(Number(this.getAttribute(`data-upsell-product-${index}-price`)), Math.abs(Number(discountValue))),
          [`kitUnitPriceWithDiscountCodeAndPixDiscount`]: this.calculatePrice(
              this.calculatePrice(Number(this.getAttribute(`data-upsell-product-${index}-price`)),
              Math.abs(Number(discountValue))),
              Math.abs(Number(this.dataset.pixDiscountValue)))
          };
        });

        const priceObject = {
          placement: this.dataset.placement,
          type: type,
          productId: this.dataset.productId,
          discountValue: Math.abs(Number(discountValue)) || 0,
          discountCode: discountCode || partnerDiscountCode,
          discountType: discountType,
          partnerDiscountCode: partnerDiscountCode,
          partnerDiscountType: partnerDiscountType,
          messageColor: this.dataset.messageColor || null,
          compareAtPrice: this.dataset.compareAtPrice ? this.formatMoney(Number(this.dataset.compareAtPrice)) : null,
          price: this.dataset.pristinePrice ? this.formatMoney(Number(this.dataset.pristinePrice)) : null,
          priceVaries: this.dataset.priceVaries === "true" ? true : false,
          priceWithDiscountCode: this.formatMoney(this.calculatePrice(Number(this.dataset.pristinePrice), Math.abs(Number(discountValue)))),
          priceWithPixDiscount: this.formatMoney(this.calculatePrice(Number(this.dataset.pristinePrice), Math.abs(Number(this.dataset.pixDiscountValue)))),
          priceWithDiscountCodeAndPixDiscount: this.formatMoney(this.calculatePrice(this.calculatePrice(Number(this.dataset.pristinePrice), Math.abs(Number(discountValue))), Math.abs(Number(this.dataset.pixDiscountValue)))),
          isKit: this.dataset?.kitProducts === "true" ? true : false,
          isHomogeneousKit: Number(this.dataset?.kitItemCount) === 1 ? true : false,
          kitQuantity: this.dataset.kitItemQuantity ? Number(this.dataset.kitItemQuantity) : undefined,
          kitCompareAtPrice: this.formatMoney((Number(this.dataset.compareAtPrice))),
          kitUnitCompareAtPrice: this.formatMoney((Number(this.dataset.compareAtPrice) / Number(this.dataset.kitItemQuantity))),
          kitFinalPrice: this.formatMoney((Number(this.dataset.kitFinalPrice) * 100)),
          kitFinalPriceWithPixDiscount: this.formatMoney(this.calculatePrice((Number(this.dataset.kitFinalPrice) * 100), Math.abs(Number(this.dataset.pixDiscountValue)))),
          kitFinalPriceWithDiscountCode: this.formatMoney(this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100, Math.abs(Number(discountValue)))),
          kitFinalPriceWithDiscountCodeAndPixDiscount: this.formatMoney(this.calculatePrice(
            this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100, Math.abs(Number(discountValue))),
            Math.abs(Number(this.dataset.pixDiscountValue)))),

          kitUnitPrice: this.formatMoney((Number(this.dataset.kitFinalPrice) * 100) / Number(this.dataset.kitItemQuantity)),
          kitUnitPriceWithPixDiscount: this.formatMoney(this.calculatePrice((Number(this.dataset.kitFinalPrice) * 100) / Number(this.dataset.kitItemQuantity), Math.abs(Number(this.dataset.pixDiscountValue)))),
          kitUnitPriceWithDiscountCode: this.formatMoney(this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100 / Number(this.dataset.kitItemQuantity), Math.abs(Number(discountValue)))),
          kitUnitPriceWithDiscountCodeAndPixDiscount: this.formatMoney(this.calculatePrice(
            this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100 / Number(this.dataset.kitItemQuantity),
            Math.abs(Number(discountValue))),
            Math.abs(Number(this.dataset.pixDiscountValue)))),
          pointsGroups: [
            {
              multiplier: discountConfigMultiplier,
              multiplierClub: discountConfigMultiplierClub,
              textGroup1: discountConfigTextGrup1,
              textGroup2: discountConfigTextGrup2,
            }
          ],
          kitUpsell: kitUpsell
        };
        this.log("Price Object:", priceObject);
        return priceObject
      }

      calculatePrice(price: number, discount: number) {
        const finalPrice = price * (1 - discount / 100);
        return finalPrice;
      }

      formatMoney(price: number) {
        const value = Math.round(price / 100);
        if(Number.isNaN(value)) return undefined;
        const priceDisplay = ` R$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        return priceDisplay;
      }

      setPriceConditions() {
        this.log("setPriceConditions")
        const partnerDiscountType = this.discountCodesStoraged?.discount_config?.type;
        const productId = Number(this.dataset?.productId);
        const productCollections = this.dataset?.productCollections?.split(",").map(Number) || [];
        const isToShowCouponDiscount = this.dataset?.isToShowCouponDiscount ? JSON.parse(this.dataset.isToShowCouponDiscount) : false;

        const hasDefaultDiscountCode = this.discountCodesStoraged?.discount_default;
        const hasOtherDiscountCode = this.discountCodesStoraged?.code;

        let hasAppliedDiscountCode = false;

        // Função auxiliar para verificar se um desconto é válido para o produto
        const isDiscountValid = (discountSource) => {
          if (!discountSource) return false;
          if (discountSource?.discount?.allocation_method === "across") return true;
          if (discountSource?.discount?.allocation_method === "each") {
            const collections = discountSource?.discount?.entitled_collection_ids || [];
            const products = discountSource?.discount?.entitled_product_ids || [];
            return (collections.some(id => productCollections.includes(id)) || products.includes(productId));
          }
          return false;
        };

        // Verifica primeiro desconto do usuário, depois o desconto padrão
        if (hasOtherDiscountCode && isDiscountValid(this.discountCodesStoraged?.data) && isToShowCouponDiscount) {
          this.log("Discount code applied:", this.discountCodesStoraged?.code);
          hasAppliedDiscountCode = true;
        } else if (hasDefaultDiscountCode && isDiscountValid(this.discountCodesStoraged?.discount_default) && isToShowCouponDiscount) {
          this.log("Discount code applied 2:", this.discountCodesStoraged?.discount_default);
          hasAppliedDiscountCode = true;
        }

        // Regras que desativam o desconto
        if (["points", "cashback"].includes(partnerDiscountType)) {
          hasAppliedDiscountCode = false;
        }

        if(hasOtherDiscountCode && this.discountCodesStoraged?.data?.discount?.value_type !== "percentage"){
          hasAppliedDiscountCode = false;
        }


        {
          this.conditionsValues = {
            hideDefaultMessage: this.discountCodesStoraged?.disable_default_message,
            hasAppliedDiscountCode: hasAppliedDiscountCode,
            hasMarkdown: Number(this.dataset?.compareAtPrice) > Number(this.dataset?.pristinePrice),
            isDiscountCodeAppliedValidForProduct: !!this.discountCodesStoraged?.data?.discount?.entitled_product_ids?.includes(Number(this.dataset.productId)),
            isCashbackDiscountCode: partnerDiscountType === "cashback" ? true : false,
            isPointsDiscountCode: partnerDiscountType === "points" ? true : false,
            isPixDiscountCodeActive: this.dataset.pixEnable === "true" && this.dataset.pixShowing === "true",
            isKit: !!this.dataset?.kitProducts,
            isHomogeneousKit: Number(this.dataset?.kitItemCount) === 1 ? true : false,
          };
        }
      }

      changePriceCouponKit(price: number, evt: Element){
        const kitContainer = evt.querySelector(".container-discount-kit-element")
        if(kitContainer) {
          const kitContainerPrice = kitContainer.querySelector(".price")
          if(kitContainerPrice) kitContainerPrice?.remove();
          let discountValue = this.discountCodesStoraged?.data?.discount?.value || this.discountCodesStoraged?.discount_default?.discount?.value;
          kitContainer.prepend(this.createPriceElement(this.formatMoney(this.calculatePrice(price, Math.abs(Number(discountValue)))), "coupon-price"));
        }
      }


      createPriceElement(price: string, extraClass?: string) {
        this.log("createPriceElement", price, extraClass);
        const container = document.createElement('span');
        container.className = extraClass ? `init-price ${extraClass}` : 'init-price';
        container.textContent = price;
        return container;
      }
      createPixCouponElement(price: string) {
        this.log("createPixCouponElement", price);
        const container = document.createElement('span');
        container.className = 'pix-price';
        const prefixText = document.createTextNode(' (no pix ');
        const valueSpan = document.createElement('span');
        valueSpan.className = 'pix-price-value';
        valueSpan.textContent = price;
        const closingText = document.createTextNode(')');
        container.appendChild(prefixText);
        container.appendChild(valueSpan);
        container.appendChild(closingText);
        return container;
      }
      createPriceMarkdownElement(price: string) {
        this.log("createPriceMarkdownElement", price);
        const container = document.createElement("span");
        container.className = "markdown-price";
        container.textContent = price;
        return container;
      }
      createCouponElement(couponCode: string) {
        this.log("createCouponElement", couponCode);
        const container = document.createElement("span");
        container.className = "coupon-code-message";
        const prefixText = document.createTextNode(' com cupom ');

        const valueSpan = document.createElement('span');
        valueSpan.className = 'coupon-code';
        valueSpan.textContent = couponCode;

        container.appendChild(prefixText);
        container.appendChild(valueSpan);
        return container;
      }


      createPointsElement(priceObject: any) {
        this.log("createPointsElement");
        // Remove existing points container if present
        const pointsContainerSelect = this.parentElement?.querySelector(".points-container");
        if(pointsContainerSelect) pointsContainerSelect?.remove();

        // Main container

        const pointsContainer = document.createElement("div");
        pointsContainer.classList.add("points-container");
        pointsContainer.id = "partners-points-container";

        // Points text with coupon code
        const pointsText = document.createElement("span");
        pointsText.classList.add("points-text");
        pointsText.textContent = `Cliente ${priceObject.partnerDiscountCode} ganha pontos com o cupom `;
        const couponCodeSpan = document.createElement("span");
        couponCodeSpan.textContent = priceObject.partnerDiscountCode;
        couponCodeSpan.classList.add("coupon-code");
        pointsText.appendChild(couponCodeSpan);

        // Club block with points details
        const clubBlock = document.createElement("div");
        clubBlock.classList.add("club-block");
        const price = Number(priceObject.price?.replace("R$", ""));
        const group = priceObject.pointsGroups[0];
        const points1 = group.multiplier * price;
        const points2 = group.multiplierClub * price;

        const itemClub1 = document.createElement("div");
        itemClub1.textContent = `${group.textGroup1}: `;
        const point1 = document.createElement("span");
        point1.textContent = `${points1} pontos`;
        itemClub1.appendChild(point1);

        const itemClub2 = document.createElement("div");
        itemClub2.textContent = `${group.textGroup2}: `;
        const point2 = document.createElement("span");
        point2.textContent = `${points2} pontos`;
        itemClub2.appendChild(point2);
        // Add clubs to club block (order preserved)
        clubBlock.append(itemClub2, itemClub1);
        pointsContainer.append(pointsText, clubBlock);
        // Insert into DOM based on placement
        const isCard = priceObject.placement === "card";
        const isPdpDesk = priceObject.placement === "pdp-desk";
        const isPdpMob = priceObject.placement === "pdp-mob" && window.innerWidth < 750;
        const isPdk = priceObject.placement === "pdk";
        if (isCard){
          const productCardColorSelector = this.parentElement.querySelector("product-card-color-selector");
          if(productCardColorSelector) productCardColorSelector?.after(pointsContainer);
        } else if (isPdpDesk) {
          this.after(pointsContainer)
        } else if (isPdpMob) {
          const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".Product__InfoWrapper");
          mediaWrapper?.querySelector(".points-container")?.remove();
          pointsContainer.style.marginBottom = "8px";
          if(mediaWrapper) mediaWrapper.prepend(pointsContainer);
        } else if (isPdk) {
          this.parentElement.appendChild(pointsContainer);
        }
      }
      createCashbackElement(priceObject: any) {
        this.log("createCashbackElement");
        const cashbackContainerSelect = this.parentElement.querySelector(".cashback-container");
        if(cashbackContainerSelect) cashbackContainerSelect?.remove();

        const cashbackContainer = document.createElement("div")
        cashbackContainer.classList.add("cashback-container");
        cashbackContainer.id = "partners-cashback-container";


        const cashbackText = document.createElement("span");
        const price = Number(priceObject.price.replace("R$", ""));
        const multiplier = priceObject.pointsGroups[0].multiplier;
        const cashbackValue = this.formatMoney(multiplier * price);

        const couponCodeSpan = document.createElement("span");
        couponCodeSpan.textContent = priceObject.partnerDiscountCode;
        couponCodeSpan.classList.add("coupon-code");

        cashbackText.textContent = `${cashbackValue} de cashback com cupom `;
        cashbackText.appendChild(couponCodeSpan);
        cashbackContainer.appendChild(cashbackText);

        // Inserção no DOM com base no placement
        const isCard = priceObject.placement === "card";
        const isPdpDesk = priceObject.placement === "pdp-desk";
        const isPdpMob = priceObject.placement === "pdp-mob" && window.innerWidth < 750;
        const isPdk = priceObject.placement === "pdk";

        if (isCard) {
          const productCardColorSelector = this.parentElement.querySelector("product-card-color-selector");
          if(productCardColorSelector) productCardColorSelector?.after(cashbackContainer);
        } else if (isPdpDesk) {
          this.after(cashbackContainer);
        } else if (isPdpMob) {
          const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".Product__InfoWrapper");
          mediaWrapper?.querySelector(".cashback-container")?.remove();
          cashbackContainer.style.marginBottom = "8px";
          if(mediaWrapper) mediaWrapper.prepend(cashbackContainer);
        } else if (isPdk) {
          this.parentElement.appendChild(cashbackContainer);
        }
      }

      setDiscountFlagElement(compareAtPrice: string, price: string, placement: string = this.dataset.placement) {
        this.log("setDiscountFlagElement", compareAtPrice, price, placement);
        const compareAtPriceValue = Number(compareAtPrice.replace("R$", "").replace(/\./g, "").replace(",", "."));
        const priceValue = Number(price.replace("R$", "").replace(/\./g, "").replace(",", "."));
        const discountPercentage = Math.round(((compareAtPriceValue - priceValue) / compareAtPriceValue) * 100);

        const labelsProductDetail = document.createElement("div");
        labelsProductDetail.classList.add("labels-product-detail");

        const productItemLabelList = document.createElement("div");
        if (compareAtPriceValue > priceValue) {
          productItemLabelList.id = "automatic-flag-label-detail-element";
          productItemLabelList.classList.add("ProductItem__LabelList", "custom-labels", "custom-top-right");
          const productItemLabel = document.createElement("span");
          productItemLabel.classList.add("ProductItem__Label", "Heading", "Text--subdued");
          productItemLabel.textContent = `${discountPercentage}% OFF`;
          productItemLabelList.appendChild(productItemLabel);
          labelsProductDetail.appendChild(productItemLabelList);
        }
         // Insert into DOM based on placement
        const isCard = placement === "card";
        const isPdpDesk = placement === "pdp-desk";
        const isPdpMob = placement === "pdp-mob" && window.innerWidth < 750;
        const isPdk = placement === "pdk";

        if (isCard){
          const flag = this.parentElement.parentElement.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
          const label = this.parentElement.parentElement.parentElement.parentElement.querySelector(".labels-products");
          if(flag) flag?.parentElement.remove();
          if(label) label?.append(labelsProductDetail);
        } else if (isPdpDesk) {
          const flag = this.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
          const label = this.parentElement.parentElement.querySelector(".labels-products");
          if(flag) flag?.parentElement.remove();
          if(label) label?.append(labelsProductDetail);
        } else if (isPdpMob) {
          const flag = this.parentElement.parentElement.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
          const label = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-info-mobile--labels-products");
          if(flag) flag.parentElement.remove();
          if(label) label?.append(labelsProductDetail);
        } else if (isPdk) {
          const contentLabels = labelsProductDetail.innerHTML;
          const flag = this.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
          const label = document.querySelectorAll(".labels-products");
          if (flag) flag?.parentElement.remove();
          label.forEach(element => {
            const target = element.querySelector(".labels-product-detail");
            if (target) {
              target.innerHTML = contentLabels;
            } else {
              const newNode = document.createElement("div");
              newNode.classList.add("labels-product-detail");
              newNode.innerHTML = contentLabels;
              element.appendChild(newNode);
            }
          });
        }
      }

      findSelectedProduct(kitUpsell: any, selectedProductId: string) {
        this.log("findSelectedProduct", kitUpsell, selectedProductId);
        return kitUpsell.find((product) => {
          const values = Object.values(product);
          return values.includes(selectedProductId);
        });
      }

      renderPrices(priceObject: any) {
        this.log("renderPrices")
        let priceContainer = this.querySelector(".price-container") as HTMLDivElement | null;
        if (!priceContainer) {
          priceContainer = document.createElement("div");
          priceContainer.classList.add("price-container");
        } else {
          // Reutiliza o container existente limpando o conteúdo
          priceContainer.innerHTML = "";
        }

        // Show "A partir de" if isKit or the current variant is the minimum price
        const isMinVariant =
          priceObject.priceVaries === true &&
          this.dataset.pristinePrice &&
          this.dataset.minPrice &&
          Number(this.dataset.pristinePrice) === Number(this.dataset.minPrice);

        if (priceObject.isKit || isMinVariant) {
          const varies = document.createElement("span");
          varies.classList.add("price-varies");
          varies.textContent = "A partir de ";
          priceContainer.appendChild(varies);
        }

        // if (priceObject.kitUpsell && priceObject.kitUpsell.length > 0 && priceObject.placement !== "card") {
        //   const selectKitUpsellContainer = document.querySelector("cupom-kits-upsell");
        //   const kitUpsell = priceObject.kitUpsell;
        //   if (selectKitUpsellContainer) {
        //     const upsellButtons = selectKitUpsellContainer.querySelectorAll(".upsell-kits__button");
        //     upsellButtons.forEach((button) => {
        //       const selectedProduct = this.findSelectedProduct(kitUpsell, button.getAttribute("data-upsell-kits-product-id"))
        //       const upsellQuantity = Number(button.querySelector("a").textContent.trim().replace(/[^0-9\.]+/g, ""));

        //       if(upsellQuantity === 1) {
        //         button.querySelector(".discounted-price").textContent = selectedProduct ? this.formatMoney(selectedProduct.kitUnitPrice * 100) + "/un" : "";
        //       } else {
        //         button.querySelector(".discounted-price").textContent = selectedProduct ? this.formatMoney(selectedProduct.kitUnitFinalPrice * 100 / upsellQuantity) + "/un" : "";
        //       }
        //     })
        //   }
        // }

        if (priceObject.type.includes("Points")) {
          this.createPointsElement(priceObject);
        }
        if (priceObject.type.includes("Cashback")) {
          this.createCashbackElement(priceObject);
        }


        const isCard = priceObject.placement === "card";
        const isPdpDesk = priceObject.placement === "pdp-desk";
        const isPdpMob = priceObject.placement === "pdp-mob" && window.innerWidth < 750;
        const isPdk = priceObject.placement === "pdk";

        switch (priceObject.type) {
          case "OnlyPrice":
          case "PriceWithPoints":
          case "PriceWithCashback":
            this.dataset.type = "OnlyPrice";
            priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
            this.appendChild(priceContainer);
            break;

          case "PriceWithPix":
          case "PriceWithPointsAndPix":
          case "PriceWithCashbackAndPix":
            this.dataset.type = "PriceWithPix";
            priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
            priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithPixDiscount));
            this.appendChild(priceContainer);
            break;

          case "PriceWithDiscountCode":
            this.dataset.type = "PriceWithDiscountCode";

          this.setDiscountFlagElement(priceObject.price, priceObject.priceWithDiscountCode, priceObject.placement);

            if(priceObject.placement !== "card") {
              priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
            } else {
              priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.price));
            }
            priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
            priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));

            if (isPdpMob){
              this.appendChild(priceContainer)
              const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper")
              if(mediaWrapper) {
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                mediaWrapper.appendChild(priceWithDiscountCode);
              }
              const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
              if(floatingButton){
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
              const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code")
              if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                priceWithDiscountCode.style.width = "100%";
                priceWithDiscountCode.style.textAlign = "center";
                priceWithDiscountCode.style.display = "block";
                floatingButton.prepend(priceWithDiscountCode);
              }
            } else {
              this.appendChild(priceContainer);
            }
            break;

          case "PriceWithMarkdown":
          case "PriceWithPointsAndMarkdown":
          case "PriceWithCashbackAndMarkdown":
            this.dataset.type = "PriceWithMarkdown";

            if (priceObject.isKit) {
              priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
              priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPrice, priceObject.placement);
            } else {
              priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
              priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));

              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.price, priceObject.placement);
            }

            if (isCard) {
              this.appendChild(priceContainer);
            } else if (isPdpDesk) {
              this.appendChild(priceContainer);
            } else if (isPdpMob) {
              this.appendChild(priceContainer);
            } else if (isPdk) {
              this.appendChild(priceContainer);
            }
            break;

          case "PriceWithDiscountCodeAndPix":
            this.dataset.type = "PriceWithDiscountCodeAndPix";

          this.setDiscountFlagElement(priceObject.price, priceObject.priceWithDiscountCode, priceObject.placement);

            if (priceObject.placement !== "card") {
              priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
            } else {
              priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.price));
            }
            priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
            if (priceObject.placement === "card") {
              priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithDiscountCodeAndPixDiscount));
            }
            if (isPdpMob) {
              this.appendChild(priceContainer);
              const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
              if(mediaWrapper) {
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                mediaWrapper.appendChild(priceWithDiscountCode);
              }
              const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
              if(floatingButton){
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
              const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code")
              if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                priceWithDiscountCode.style.width = "100%";
                priceWithDiscountCode.style.textAlign = "center";
                priceWithDiscountCode.style.display = "block";
                floatingButton.prepend(priceWithDiscountCode);
              }
            } else {
              priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));
              this.appendChild(priceContainer);
            }
            break;

          case "PriceWithMarkdownAndPix":
          case "PriceWithPointsAndMarkdownAndPix":
          case "PriceWithCashbackAndMarkdownAndPix":
            this.dataset.type = "PriceWithMarkdownAndPix";
            priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
            // PRICE

            if (priceObject.isKit) {
              priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPrice, priceObject.placement);
            } else {
              priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.price, priceObject.placement);
            }

            // PIX
            if (priceObject.placement === "card") {
              if (priceObject.isKit) {
                priceContainer.appendChild(this.createPixCouponElement(priceObject.kitFinalPriceWithPixDiscount));
              } else {
                priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithPixDiscount));
              }
            }

            this.appendChild(priceContainer);
            break;

          case "PriceWithMarkdownAndDiscountCode":
            this.dataset.type = "PriceWithMarkdownAndDiscountCode";
            priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));

            if (priceObject.placement !== "card" && !priceObject.isKit) {
              priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
            }


            if (priceObject.isKit) {
              if (priceObject.placement === "pdk") {
                priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
                this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
                const priceContainerKit = this.parentElement.parentElement.querySelectorAll(".kit-item__info .price");
                priceContainerKit.forEach((priceElement) => {
                  const discountKitPriceElement = priceElement.querySelector(".discount-price")?.textContent.replace("R$", "").replace(" ", "").replace(",", ".");
                  if (discountKitPriceElement){
                    const priceElementDiscountKitEl = priceElement.querySelector(".container-discount-kit-element")
                    if(priceElementDiscountKitEl) priceElementDiscountKitEl?.remove();
                    let discountedPrice = this.calculatePrice(Number(discountKitPriceElement)*100, Math.abs(Number(priceObject.discountValue)));
                    const containerDiscount = document.createElement("div");
                    containerDiscount.classList.add("container-discount-kit-element");
                    containerDiscount.style.color = this.dataset.messageColor || "#3d3d3d";
                    containerDiscount.appendChild(this.createPriceElement(this.formatMoney(discountedPrice), "coupon-price"));
                    containerDiscount.appendChild(this.createCouponElement(priceObject.discountCode));
                    priceElement.appendChild(containerDiscount)
                  }
                });
              } else {
              priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPriceWithDiscountCode, "coupon-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
              }
            } else {
              priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.priceWithDiscountCode, priceObject.placement);
            }
            priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));

            if (isCard) {
              this.appendChild(priceContainer);
            } else if (isPdpDesk) {
              this.appendChild(priceContainer);
            } else if (isPdpMob) {
              this.appendChild(priceContainer);
              const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
              if(mediaWrapper) {
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                mediaWrapper.appendChild(priceWithDiscountCode);
              }
              const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
              if(floatingButton){
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
              const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code")
              if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                priceWithDiscountCode.style.width = "100%";
                priceWithDiscountCode.style.textAlign = "center";
                priceWithDiscountCode.style.display = "block";
                floatingButton.prepend(priceWithDiscountCode);
              }
            } else if (isPdk) {
              this.appendChild(priceContainer);
            }

            break;

          case "PriceWithMarkdownAndDiscountCodeAndPix":
            this.dataset.type = "PriceWithMarkdownAndDiscountCodeAndPix";
            priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
            if (priceObject.placement !== "card" && !priceObject.isKit) {
              priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
            }
            // PRICE
            if (priceObject.isKit) {
              if (priceObject.placement === "pdk") {
                priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
                this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
                const priceContainerKit = this.parentElement.parentElement.querySelectorAll(".kit-item__info .price");
                priceContainerKit.forEach((priceElement) => {
                  const discountKitPriceElement = priceElement.querySelector(".discount-price")?.textContent.replace("R$", "").replace(" ", "").replace(",", ".");
                  if (discountKitPriceElement){
                    priceElement.querySelector(".container-discount-kit-element")?.remove();
                    let discountedPrice = this.calculatePrice(Number(discountKitPriceElement)*100, Math.abs(Number(priceObject.discountValue)));
                    const containerDiscount = document.createElement("div");
                    containerDiscount.classList.add("container-discount-kit-element");
                    containerDiscount.style.color = this.dataset.messageColor || "#3d3d3d";
                    containerDiscount.appendChild(this.createPriceElement(this.formatMoney(discountedPrice), "coupon-price"));
                    containerDiscount.appendChild(this.createCouponElement(priceObject.discountCode));
                    priceElement.appendChild(containerDiscount)
                  }
                });
              } else {
              priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPriceWithDiscountCode, "coupon-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
              }
            } else {
              priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
              this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.priceWithDiscountCode, priceObject.placement);
            }

            // PIX
            if (priceObject.placement === "card") {
              if (priceObject.isKit) {
                priceContainer.appendChild(this.createPixCouponElement(priceObject.kitFinalPriceWithDiscountCodeAndPixDiscount));
              } else {
                priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithDiscountCodeAndPixDiscount));
              }
            }
            else if (priceObject.placement === "pdp-mob" && window.innerWidth < 750) {
              const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
              if(mediaWrapper) {
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                mediaWrapper.appendChild(priceWithDiscountCode);
              } 
              const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
              if(floatingButton){
                const priceWithDiscountCode = document.createElement("span");
                priceWithDiscountCode.className = "price-with-discount-code";
                priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
              const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code")
              if(priceWithDiscountCodeEl) priceWithDiscountCodeEl?.remove();
                priceWithDiscountCode.style.width = "100%";
                priceWithDiscountCode.style.textAlign = "center";
                priceWithDiscountCode.style.display = "block";
                floatingButton.prepend(priceWithDiscountCode);
              }
            }

            priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));
            this.appendChild(priceContainer);
            break;

          default:
          console.warn("Tipo de preço não tratado:", priceObject.type);
          break;

      }
      }
    }
      customElements.define("price-normalize", PriceNormalize);
    }
